<template>
  <div class="membership-container">
    <!-- 顶部Logo区域 -->
    <div class="logo-section">
      <div class="logo">
        <img src="../assets/Logo.png" style="width: 100px;">
      </div>
    </div>
    
    <div class="header">
      <h2>选择悦览PRO套餐</h2>
    </div>
    
    <div class="membership-cards">
      <div 
        v-for="plan in membershipPlans" 
        :key="plan.type"
        class="membership-card"
        :class="{ 'recommended': plan.recommended }"
        @click="selectPlan(plan)"
      >
        <div v-if="plan.recommended" class="recommended-badge">
          <span>推荐</span>
        </div>
        
        <div class="plan-header">
          <h3>{{ plan.name }}</h3>
          <div class="duration">{{ plan.duration }}</div>
        </div>
        
        <div class="price-section">
          <div class="price-main">
            <span class="currency">¥</span>
            <span class="amount">{{ plan.price }}</span>
          </div>
          <div v-if="plan.originalPrice" class="price-original">
            原价 ¥{{ plan.originalPrice }}
          </div>
        </div>
        
        <div v-if="plan.type === 'lifetime'" class="coupon-section" @click.stop>
          <div class="coupon-input-group">
            <input 
              v-model="couponCode" 
              type="text" 
              placeholder="请输入优惠码" 
              class="coupon-input"
              :disabled="isCouponValid"
            >
            <button @click="checkCoupon" class="coupon-btn" :disabled="!couponCode || isCouponValid">
              {{ isCouponValid ? '已使用' : '兑换' }}
            </button>
          </div>

          <div v-if="isCouponValid" class="discount-card">
            <div class="discount-header">
                <div class="discount-title-group">
                    <span class="discount-icon">🎉</span>
                    <span class="discount-title">优惠已生效</span>
                </div>
                <span class="discount-val">- ¥{{ discountAmount }}</span>
            </div>
            <div class="discount-desc">
                VIP专属优惠
            </div>
          </div>

          <div v-if="couponMessage" class="coupon-message" :class="{ 'error': !isCouponValid, 'success': isCouponValid }">
            {{ couponMessage }}
          </div>
        </div>

        <button class="select-btn" :class="{ 'recommended-btn': plan.recommended }">
          立即购买
        </button>
      </div>
    </div>
    
    <!-- 版权信息 -->
    <div class="footer">
      <div class="footer-text">
        购买即表示同意服务条款
      </div>
      <div class="copyright">
        <p>© 2025 珠海字符科技有限公司 版权所有</p>
        <p><a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">粤ICP备2025361041号</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MembershipView',
  data() {
    return {
      membershipPlans: [
        {
          type: 'monthly',
          name: '月度悦览PRO',
          price: 6,
          duration: '1个月'
        },
        {
          type: 'halfyear',
          name: '半年悦览PRO',
          price: 30,
          duration: '6个月'
        },
        {
          type: 'yearly',
          name: '年度悦览PRO',
          price: 58,
          originalPrice: 88,
          duration: '12个月',
          recommended: true
        },
        {
          type: 'lifetime',
          name: '永久悦览PRO',
          price: 82,
          originalPrice: 88,
          duration: '永久有效，前5000名购买活动专属ID和虚拟纪念章\n（前50名发放实体纪念章）\n(微信渠道特惠)',
          recommended: true
        }
      ],
      couponCode: '',
      couponMessage: '',
      discountAmount: 0,
      isCouponValid: false
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    const unionID = urlParams.get('unionID')
    if (unionID) {
      this.unionIDFromUrl = unionID
    }
  },
  methods: {
    selectPlan(plan) {
      const urlParams = new URLSearchParams(window.location.search)
      const unionID = urlParams.get('unionID')
      
      if (unionID) {
        this.$router.push({ 
          name: 'payment', 
          params: { type: plan.type },
          query: { unionID: unionID }
        })
      } else {
        this.$router.push({ name: 'payment', params: { type: plan.type } })
      }
    },
    async checkCoupon() {
      if (!this.couponCode) return;
      
      try {
        const response = await fetch('https://api.charactech.cn/yuelan/v2/coupon/check', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ code: this.couponCode })
        });
        
        const result = await response.json();
        
        if (result.code === 200 && result.data && result.data.valid) {
          if (result.data.type === 'vip-10') {
            const lifetimePlan = this.membershipPlans.find(p => p.type === 'lifetime');
            if (lifetimePlan) {
              lifetimePlan.price = 72;
              this.discountAmount = 10;
              this.isCouponValid = true;
              this.couponMessage = '';
            }
          } else {
            this.couponMessage = '优惠码有效，但该优惠码不适用于此商品';
            this.isCouponValid = false;
          }
        } else {
          this.couponMessage = result.msg || '优惠码无效';
          this.isCouponValid = false;
        }
      } catch (error) {
        console.error('Coupon check error:', error);
        this.couponMessage = '校验失败，请稍后重试';
        this.isCouponValid = false;
      }
    }
  }
}
</script>

<style scoped>
.membership-container {
  min-height: 100vh;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.brand-title {
  font-size: 2rem;
  font-weight: 600;
  color: #3b82f6;
  margin: 0;
}

.header {
  text-align: center;
  margin-bottom: 20px;
}

.header h2 {
  font-size: 2rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.membership-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  max-width: 1200px;
  width: 100%;
  margin-bottom: 40px;
}

.membership-card {
  background: white;
  border-radius: 12px;
  padding: 32px 24px;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.membership-card:hover {
  border-color: #3b82f6;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.membership-card.recommended {
  border-color: #3b82f6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.recommended-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: #3b82f6;
  color: white;
  padding: 8px 20px;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 0 12px 0 12px;
}

.plan-header {
  text-align: center;
  margin-bottom: 24px;
}

.plan-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.duration {
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 500;
}

.price-section {
  text-align: center;
  margin-bottom: 32px;
}

.price-main {
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-bottom: 4px;
}

.currency {
  font-size: 1.25rem;
  font-weight: 600;
  color: #3b82f6;
  margin-right: 4px;
}

.amount {
  font-size: 3rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
}

.price-original {
  font-size: 0.875rem;
  color: #94a3b8;
  text-decoration: line-through;
  font-weight: 500;
}

.select-btn {
  width: 100%;
  background: #f8fafc;
  color: #475569;
  border: 1px solid #e2e8f0;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.select-btn:hover {
  background: #e2e8f0;
  border-color: #cbd5e1;
}

.select-btn.recommended-btn {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.select-btn.recommended-btn:hover {
  background: #1d4ed8;
}

.footer {
  text-align: center;
}

.footer-text {
  font-size: 0.875rem;
  color: #94a3b8;
  margin-bottom: 20px;
}

.copyright {
  font-size: 0.75rem;
  color: #94a3b8;
  line-height: 1.6;
}

.copyright p {
  margin: 4px 0;
}

.copyright a {
  color: #3b82f6;
  text-decoration: none;
  transition: color 0.3s ease;
}

.copyright a:hover {
  color: #1d4ed8;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .membership-container {
    padding: 20px 16px;
  }
  
  .header h2 {
    font-size: 1.75rem;
  }
  
  .membership-cards {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .membership-card {
    padding: 24px 20px;
  }
  
  .amount {
    font-size: 2.5rem;
  }
  
  .recommended-badge {
    padding: 6px 16px;
    font-size: 0.7rem;
  }
}

@media (max-width: 480px) {
  .membership-container {
    padding: 16px 12px;
  }
  
  .header h2 {
    font-size: 1.5rem;
  }
  
  .membership-card {
    padding: 20px 16px;
  }
  
  .amount {
    font-size: 2.25rem;
  }
}

.coupon-section {
  margin-bottom: 20px;
  padding: 0 10px;
}

.coupon-input-group {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.coupon-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  outline: none;
  transition: border-color 0.2s;
}

.coupon-input:focus {
  border-color: #3b82f6;
}

.coupon-input:disabled {
  background-color: #f1f5f9;
  color: #94a3b8;
}

.coupon-btn {
  padding: 8px 16px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}

.coupon-btn:hover:not(:disabled) {
  background: #2563eb;
}

.coupon-btn:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
}

.coupon-message {
  font-size: 0.75rem;
  text-align: left;
  margin-top: 4px;
}

.coupon-message.error {
  color: #ef4444;
}

.coupon-message.success {
  color: #22c55e;
}

.discount-card {
    background: linear-gradient(135deg, #fff6f6 0%, #fff1f1 100%);
    border: 1px solid #fee2e2;
    border-radius: 8px;
    padding: 12px 16px;
    margin-top: 12px;
    animation: fadeIn 0.3s ease;
}

.discount-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
}

.discount-title-group {
    display: flex;
    align-items: center;
    gap: 6px;
}

.discount-icon {
    font-size: 1.1rem;
}

.discount-title {
    color: #ef4444;
    font-weight: 600;
    font-size: 0.95rem;
}

.discount-val {
    color: #ef4444;
    font-weight: 700;
    font-size: 1.1rem;
}

.discount-desc {
    color: #b91c1c;
    font-size: 0.8rem;
    opacity: 0.8;
    margin-left: 28px;
}
</style>